import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useListNeedsQuery } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { urls } from "../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

export const MyNeedsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();
  const authState = useLoggedInWithOrgContextState();
  const { data, isLoading, isError } = useListNeedsQuery({});
  // No server-side "mine" filter for needs, so scope to the current user client-side by
  // createdBy (needs have no responsible buyer; the event panels scope server-side instead).
  const needs = (data?.needs ?? []).filter((n) => n.createdBy?.id === authState.me.id).slice(0, 6);

  return (
    <HomePanel titleKey="My needs" seeAllTo={urls.app.needs.mine} isLoading={isLoading} isError={isError} isEmpty={needs.length === 0} emptyKey="No needs yet">
      <PanelTable headers={[t("Title"), t("Created")]}>
        {needs.map((n) => (
          <PanelRow key={n.id} onClick={() => navigate(urls.app.needs.view.go(n.id))}>
            <TitleCell title={n.title || t("Untitled")} />
            <MutedCell>{displayDate(n.createdAt)}</MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
